<template>
   <div>
   <Home />
    </div>
</template>

<script>
import Home from "../ResearchPages/Home.vue";

export default {
components:{
Home, 

},
}
</script>

<style>

</style>